async function namegen() {
    const input = document.getElementById('name-input');
    const name = input.value.trim();
    if (!name) {
      alert('Please enter a name');
      return;
    }

    console.log("names generated!");

    document.getElementById('regenerate-btn').style.display = 'inline-block';

    try {
      // Replace with your actual API URL and add query param ?name=...
      
      const response = await fetch('https://9f2zmii84c.execute-api.us-east-1.amazonaws.com/dev-api?name=' + encodeURIComponent(name), {
        headers: {
          'Content-Type': 'application/json',
        }
      })
      const names = await response.json();
       // Clear old lists
      document.getElementById('name-list-1').innerHTML = '';
      document.getElementById('name-list-2').innerHTML = '';

      // Add first 10 to first list, next 10 to second list
      names.slice(0, 10).forEach(n => {
        let li = document.createElement('li');
        li.textContent = n;
        li.style.marginBottom = '8px';  // add vertical space between items
        document.getElementById('name-list-1').appendChild(li);
      });
      names.slice(10, 20).forEach(n => {
        let li = document.createElement('li');
        li.textContent = n;
        li.style.marginBottom = '8px';  // add vertical space between items
        document.getElementById('name-list-2').appendChild(li);
      });
    } catch (err) {
      alert('Failed to fetch names');
      console.error(err);
    }
  }

// event listeners for generate / regenreate buttons
  document.getElementById('generate-btn').addEventListener('click', namegen);
  document.getElementById('regenerate-btn').addEventListener('click', namegen);